export default "__VITE_ASSET__ikF0E0_T__"